import { useLocation } from "react-router-dom";
import SeoHead from "./SeoHead";
import JsonLd from "./JsonLd";
import { ROUTES } from "../../constants/routes";
import { useProductSeo } from "../../context/ProductSeoContext";
import { resolveSeoPageId } from "../../utils/seo";

function SeoManager() {
  const { pathname } = useLocation();
  const { productSeo } = useProductSeo();
  const pageId = resolveSeoPageId(pathname);

  const overrides =
    pageId === "productDetail" && productSeo
      ? {
          title: productSeo.title,
          description: productSeo.description,
          image: productSeo.image,
          path: `${ROUTES.products}/${productSeo.slug}`,
          ogType: "product",
        }
      : null;

  return (
    <>
      <SeoHead pageId={pageId} overrides={overrides} />
      <JsonLd pageId={pageId} />
    </>
  );
}

export default SeoManager;
